(function () {
    const DATA = {
      handle: "double-extendable-dining-table",
      product: "Double Extendable Dining Table",
      collection: "Double",
      intro: "The Double extendable dining table is a successful combination of pure lines and a solid look. Although the table looks heavy, it can very easily be extended single-handedly. It takes a few steps and no more than seconds to make space for whatever will be happening next in your home.",
      default_sku: "52066",
      default_colour: "oak",
      line_img: "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_ld_52066.jpg",
      colours: {
        oak: {
          id: "oak",
          label: "Oak",
          care: "https://www.baysidefurniture.com.au/pages/oak-furniture-care",
          care_label: "Oak furniture care",
          swatch: "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p3_sw_MAR-105910_Oak_Natural_011.jpg",
          lifestyle: [
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_207ab36a02.jpg"
          ]
        },
        "teak-natural": {
          id: "teak-natural",
          label: "Teak Natural",
          care: "https://www.baysidefurniture.com.au/pages/teak-furniture-care",
          care_label: "Teak furniture care",
          swatch: "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p3_sw_MAR-101005_Teak_Natural_200.jpg",
          intro_extra: "<p>To enhance the natural material beauty, this teak product comes without any finishing or protective treatment applied. For more information, please refer to the <a href=\"https://www.baysidefurniture.com.au/pages/teak-furniture-care\" target=\"_blank\" rel=\"noopener noreferrer\">care and maintenance instructions for natural teak</a>.</p>",
          lifestyle: [
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_3ef919da29.jpg",
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_1ff3ed4f97.jpg",
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_da90c9d007.jpg"
          ]
        }
      },
      skus: [
        {
          sku: "52066",
          handle: "oak-double-extension-dining-table",
          colour: "oak",
          colour_label: "Oak",
          finish: "Oak · Oiled",
          range: "200-300",
          extendable: true,
          L: "200", W: "100", H: "76", kg: "150",
          gallery: [
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_03ea5f30ae.jpg",
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_fec62333e5.jpg",
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_cce2b148ec.jpg",
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_0eb6b9e5f4.jpg",
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_bf73bc5125.jpg",
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_f18c776769.jpg",
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_bb173ea021.jpg",
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_af840de059.jpg",
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_22f2a485cc.jpg"
          ],
          packs: [
            {n: 1, L: "210", W: "110", H: "21.5", kg: ""},
            {n: 2, L: "56", W: "28", H: "65", kg: ""}
          ],
          specs: [
            {name: "Extendable", value: "Yes"},
            {name: "Comfortably seats up to", value: "8 people, extending to seat up to 12 people"},
            {name: "Extends up to", value: "300 cm / 118.11 in"},
            {name: "Shape", value: "Rectangular"},
            {name: "Colour", value: "Natural"},
            {name: "Collection", value: "Double"},
            {name: "Construction", value: "Ready to be assembled"},
            {name: "Indoor / Outdoor", value: "For indoor use only"},
            {name: "Main Material", value: "Oak"},
            {name: "Material Description", value: "Made from solid oak with a hardwax oil finish."},
            {name: "Finish", value: "Oiled"},
            {name: "Solid wood", value: "Yes"},
            {name: "Max weight", value: "170 KG"}
          ],
          sheet: "https://file.epmapplication.net:9010/array1/epma/FILES/product_sheet/product_sheet_52066_eu.pdf",
          line: "https://file.epmapplication.net:9010/array1/epma/FILES/line_drawing/Double%20extendable%20dining%20table%20LD.pdf",
          assembly: "https://file.epmapplication.net:9010/array1/epma/FILES/assembly_instruction/Double%20dining%20table%20%28RS%29%20-%20all%20oak%20-%20assembly%20AI.pdf",
          cad: "https://file.epmapplication.net:9010/array1/epma/FILES/3D_asset/ETH_52066_Double_ExtendableDiningTable_200-300x100x76.zip"
        },
        {
          sku: "12066",
          handle: "ethnicraft-teak-double-extension-dining-table",
          colour: "teak-natural",
          colour_label: "Teak Natural",
          finish: "Teak Natural",
          range: "200-300",
          extendable: true,
          L: "200", W: "100", H: "76", kg: "103",
          gallery: [
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_8254de4f1e.jpg",
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_d37374874a.jpg",
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_8f7f450951.jpg",
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_f259c03152.jpg",
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_977130f431.jpg",
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_6eb5b63627.jpg",
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_d3dd954aaa.jpg",
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_a986d1f836.jpg",
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_5d1702c3b5.jpg",
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_fd78dca70a.jpg",
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_f2bc7dfe56.jpg",
            "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_dedt_8564083f6b.jpg"
          ],
          packs: [
            {n: 1, L: "215", W: "119", H: "30", kg: "110"},
            {n: 2, L: "67", W: "56", H: "27", kg: "26.5"}
          ],
          specs: [
            {name: "Extendable", value: "Yes"},
            {name: "Comfortably seats up to", value: "8 people, extending to seat up to 12 people"},
            {name: "Extends up to", value: "300 cm / 118.11 in"},
            {name: "Shape", value: "Rectangular"},
            {name: "Colour", value: "Natural"},
            {name: "Collection", value: "Double"},
            {name: "Construction", value: "Ready to be assembled"},
            {name: "Indoor / Outdoor", value: "For indoor use only"},
            {name: "Main Material", value: "Teak"},
            {name: "Solid wood", value: "Yes"},
            {name: "Max weight", value: "170 KG"}
          ],
          sheet: "https://file.epmapplication.net:9010/array1/epma/FILES/product_sheet/product_sheet_12066_eu.pdf",
          line: "https://file.epmapplication.net:9010/array1/epma/FILES/line_drawing/Double%20extendable%20dining%20table%20LD.pdf",
          assembly: "https://file.epmapplication.net:9010/array1/epma/FILES/assembly_instruction/Double%20dining%20table%20-%20all%20teak%20-%20assembly%20AI.pdf",
          cad: "https://file.epmapplication.net:9010/array1/epma/FILES/3D_asset/ETH_12066_Double_ExtendableDiningTable_200-300x100x76.zip"
        }
      ],
      pair_seating: {
        oak: {
          chair: {
            href: "https://www.baysidefurniture.com.au/pages/bok-dining-chair?sku=51490",
            img: "https://cdn.shopify.com/s/files/1/0474/8712/3608/products/51490_Oak-Bok-Dining-Chair_Front.jpg",
            label: "Bok dining chair"
          },
          bench: {
            href: "https://www.baysidefurniture.com.au/pages/bok-bench?sku=51533",
            img: "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/p4_mod_51533_main.jpg",
            label: "Bok bench"
          }
        },
        "teak-natural": {
          chair: {
            href: "https://www.baysidefurniture.com.au/pages/bok-dining-chair?sku=10156",
            img: "https://cdn.shopify.com/s/files/1/0474/8712/3608/products/10156TeakBokdiningchair-withoutarmrest_p.jpg",
            label: "Bok dining chair"
          },
          bench: {
            href: "https://www.baysidefurniture.com.au/products/ethnicraft-10149-bok-bench",
            img: "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/zoom_wf_10149_Teak_Bok_bench_186_profile_WEB.jpg",
            label: "Bok bench"
          }
        }
      },
      pair_objects: [
        {href: "https://www.baysidefurniture.com.au/products/ethnicraft-29801-natural-pine-bowls-set", img: "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/29801.jpg?v=1789361245", label: "Natural Pine Bowls Set of 3"},
        {href: "https://www.baysidefurniture.com.au/products/natural-organic-sculpture", img: "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/29703_Natural_Organic_sculpture_mahogany_front1_cut_WEB.jpg?v=1689297096", label: "Object Mahogany Organic"},
        {href: "https://www.baysidefurniture.com.au/products/pi-book-ends-dark-brown", img: "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/1_e7f4f2d7-c40c-4cfe-9b7b-677d7502f991.jpg?v=1687318645", label: "Object Mahogany Dark Brown PI Book Ends"},
        {href: "https://www.baysidefurniture.com.au/products/striped-bowl", img: "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/Picture1bowl.jpg?v=1687310552", label: "Mahogany Black Striped Bowl"},
        {href: "https://www.baysidefurniture.com.au/products/japan-board", img: "https://cdn.shopify.com/s/files/1/0474/8712/3608/files/Picture2Japanboard.jpg?v=1687312029", label: "Mahogany Black Japan Board"}
      ]
    };

    const byId = (id) => document.getElementById(id);
    const galleries = { piece: [], life: [] };
    const accOpen = {};
    let pairObject = null;
    let shopifyActive = null;
    const EMPTY = "\u2014";

    function colourOf(id) { return DATA.colours[id] || {}; }
    function isListed(it) {
      if (!it || !it.handle) return false;
      const Hub = window.BaysideHubStatus;
      if (Hub && Hub.isActive && shopifyActive) return Hub.isActive(it, shopifyActive, null);
      return true;
    }
    function longest(it) {
      const nums = String(it.range || "").match(/\d+(?:\.\d+)?/g) || ["0"];
      return Math.max.apply(null, nums.map(Number));
    }
    function skusForColour(id) {
      return DATA.skus.filter((s) => s.colour === id && isListed(s)).sort((a, b) => longest(a) - longest(b) || String(a.sku).localeCompare(String(b.sku)));
    }
    function current() {
      const list = skusForColour(byId("colour").value);
      return list.find((s) => s.sku === byId("sku").value) || list[0] || DATA.skus[0];
    }
    function sizeLabel(it) {
      const range = String(it.range || "").replace(/-/g, "\u2013");
      const dim = range ? ( /cm$/i.test(range) ? range : range + "cm" ) : "";
      const parts = [it.sku, it.colour_label];
      if (dim) parts.push(dim);
      if (it.extendable) parts.push("Extendable");
      return parts.join(" \u00b7 ");
    }
    function syncEnquireHref() {
      const link = document.querySelector(".enquire-btn");
      if (!link) return;
      link.href = window.matchMedia("(max-width:860px)").matches ? "#accordions" : "#enquire";
    }
    function dedupeLife(urls) {
      const seen = {};
      const out = [];
      (urls || []).forEach((src) => {
        const name = String(src).split("/").pop().split("?")[0].toLowerCase();
        const generic = /_(lifestyle|inspirational\d*)\./i.test(name);
        const key = generic ? "generic" : src;
        if (seen[key]) return;
        seen[key] = true;
        out.push(src);
      });
      return out;
    }
    function loaded(kind) {
      return (galleries[kind] || []).filter((item) => item.loaded);
    }
    function renderThumbs(host, items, kind) {
      host.innerHTML = "";
      items.forEach((item) => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.hidden = true;
        const img = document.createElement("img");
        img.alt = item.alt || "";
        img.addEventListener("load", () => {
          item.loaded = true;
          btn.hidden = false;
          markActive(kind);
        });
        img.addEventListener("error", () => {
          const list = galleries[kind];
          const idx = list.indexOf(item);
          if (idx >= 0) list.splice(idx, 1);
          btn.remove();
          const stageId = kind === "piece" ? "pieceImg" : "heroImg";
          if (byId(stageId).getAttribute("data-src") === item.src) {
            const next = list.find((x) => x.loaded) || list[0];
            if (next) {
              if (kind === "piece") selectPiece(next);
              else selectLife(next);
            }
          }
        });
        img.src = item.src;
        btn.appendChild(img);
        btn.addEventListener("click", () => {
          if (kind === "piece") selectPiece(item);
          else selectLife(item);
        });
        host.appendChild(btn);
      });
    }
    function markActive(kind) {
      const stageId = kind === "piece" ? "pieceImg" : "heroImg";
      const hostId = kind === "piece" ? "pieceThumbs" : "heroThumbs";
      const src = byId(stageId).getAttribute("data-src");
      Array.from(byId(hostId).querySelectorAll("button")).forEach((btn) => {
        const thumb = btn.querySelector("img");
        btn.classList.toggle("active", !!(thumb && thumb.src && thumb.getAttribute("src") === src));
      });
    }
    function selectPiece(item) {
      const img = byId("pieceImg");
      img.src = item.src;
      img.alt = item.alt || "";
      img.setAttribute("data-src", item.src);
      markActive("piece");
    }
    function selectLife(item) {
      const img = byId("heroImg");
      img.src = item.src;
      img.alt = item.alt || "";
      img.setAttribute("data-src", item.src);
      markActive("life");
    }
    function renderPiece(it) {
      const items = (it.gallery || []).map((src) => ({
        src: src,
        alt: "Ethnicraft " + DATA.product + " \u00b7 " + it.colour_label + " \u00b7 SKU " + it.sku,
        loaded: false
      }));
      const swatch = colourOf(it.colour).swatch;
      if (swatch) items.push({ src: swatch, alt: "Ethnicraft " + DATA.product + " \u00b7 " + it.colour_label + " swatch", loaded: false });
      if (DATA.line_img) items.push({ src: DATA.line_img, alt: "Technical line drawing \u00b7 SKU " + it.sku, loaded: false });
      galleries.piece = items;
      if (items[0]) selectPiece(items[0]);
      renderThumbs(byId("pieceThumbs"), items, "piece");
    }
    function renderLife(it) {
      const shots = dedupeLife((colourOf(it.colour).lifestyle) || []);
      const items = shots.map((src) => ({
        src: src,
        alt: "Ethnicraft " + DATA.product + " lifestyle \u00b7 " + it.colour_label,
        loaded: false
      }));
      galleries.life = items;
      if (items[0]) selectLife(items[0]);
      else {
        byId("heroImg").removeAttribute("src");
        byId("heroImg").alt = "";
        byId("heroImg").setAttribute("data-src", "");
      }
      renderThumbs(byId("heroThumbs"), items, "life");
    }
    function renderAcc(it) {
      const lwh = (it.L && it.W && it.H) ? (it.L + " \u00d7 " + it.W + " \u00d7 " + it.H + " cm") : EMPTY;
      const net = it.kg ? (it.kg + " kg") : EMPTY;
      const packs = it.packs || [];
      const box = packs.map((p) => {
        const finish = it.finish + (packs.length > 1 ? (" \u00b7 Box " + p.n) : "");
        const dims = (p.L || EMPTY) + " \u00d7 " + (p.W || EMPTY) + " \u00d7 " + (p.H || EMPTY) + " cm";
        const gross = p.kg ? (p.kg + " kg") : EMPTY;
        return "<tr><td>" + it.sku + "</td><td>" + finish + "</td><td>" + dims + "</td><td>" + gross + "</td></tr>";
      }).join("");
      let spec = '<table class="eth-spec-table">';
      (it.specs || []).forEach((row) => { spec += "<tr><th>" + row.name + "</th><td>" + row.value + "</td></tr>"; });
      spec += "<tr><th>SKU</th><td>" + it.sku + "</td></tr></table>";
      const lines = [];
      lines.push("<strong>Collection:</strong> " + DATA.collection);
      lines.push("<strong>Variant:</strong> " + it.colour_label);
      if (it.assembly) lines.push('<strong>Assembly Instructions:</strong> <a target="_blank" rel="noopener noreferrer" href="' + it.assembly + '">Click to view PDF</a>');
      if (it.sheet) lines.push('<strong>Official Product Data Sheet \u00b7 SKU ' + it.sku + ':</strong> <a target="_blank" rel="noopener noreferrer" href="' + it.sheet + '">Click to view PDF</a>');
      if (it.line) lines.push('<strong>Technical line drawing:</strong> <a target="_blank" rel="noopener noreferrer" href="' + it.line + '">Click to view PDF</a>');
      if (it.cad) lines.push('<strong>3D Models:</strong> <a target="_blank" rel="noopener noreferrer" href="' + it.cad + '">CAD</a>');
      lines.push('Find all media assets in our <a href="https://ethnicraft.canto.global/v/mediacentre/library" target="_blank" rel="noopener noreferrer">Media Centre</a>');
      const colour = colourOf(it.colour);
      const care = colour.care
        ? ('<p><a href="' + colour.care + '" target="_blank" rel="noopener noreferrer">' + (colour.care_label || "Care") + "</a></p>")
        : "<p></p>";
      byId("accordions").innerHTML =
        '<details class="eth" data-key="dims"><summary>Product dimensions</summary><div class="eth-body"><table><thead><tr><th>SKU</th><th>Finish</th><th>L \u00d7 W \u00d7 H</th><th>Net</th></tr></thead><tbody><tr><td>' + it.sku + "</td><td>" + it.finish + "</td><td>" + lwh + "</td><td>" + net + "</td></tr></tbody></table>" +
        (box ? '<p class="eth-dim-sub">Box dimensions</p><table><thead><tr><th>SKU</th><th>Finish</th><th>L \u00d7 W \u00d7 H</th><th>Gross</th></tr></thead><tbody>' + box + "</tbody></table>" : "") +
        "</div></details>" +
        '<details class="eth" data-key="specs"><summary>Specifications</summary><div class="eth-body">' + spec + "</div></details>" +
        '<details class="eth" data-key="care"><summary>Care &amp; Maintenance</summary><div class="eth-body">' + care + "</div></details>" +
        '<details class="eth" data-key="res"><summary>Resources</summary><div class="eth-body"><p>' + lines.join("<br>") + "</p></div></details>";
      byId("accordions").querySelectorAll("details.eth").forEach((d) => {
        if (accOpen[d.dataset.key]) d.open = true;
        d.addEventListener("toggle", () => { accOpen[d.dataset.key] = d.open; });
      });
    }
    function renderSwatches() {
      const row = byId("swatchRow");
      row.innerHTML = "";
      Object.keys(DATA.colours).forEach((id) => {
        if (!skusForColour(id).length) return;
        const colour = DATA.colours[id];
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "swatch-tile" + (id === byId("colour").value ? " active" : "");
        if (colour.swatch) btn.style.backgroundImage = "url('" + colour.swatch + "')";
        btn.setAttribute("aria-label", colour.label);
        btn.addEventListener("click", () => { byId("colour").value = id; onColour(); });
        row.appendChild(btn);
      });
    }
    function fillColours() {
      const ids = Object.keys(DATA.colours).filter((id) => skusForColour(id).length);
      byId("colour").innerHTML = ids.map((id) => '<option value="' + id + '">' + DATA.colours[id].label + "</option>").join("");
      byId("colour").value = DATA.default_colour;
    }
    function fillSizes() {
      const list = skusForColour(byId("colour").value);
      byId("sku").innerHTML = list.map((it) => '<option value="' + it.sku + '">' + sizeLabel(it) + "</option>").join("");
      if (!list.some((it) => it.sku === byId("sku").value) && list[0]) byId("sku").value = list[0].sku;
    }
    function onColour() { fillSizes(); apply(); }
    function renderPairs(it) {
      const host = byId("pairsWell");
      if (!host) return;
      const seating = (DATA.pair_seating || {})[it.colour] || {};
      const pool = (DATA.pair_objects || []).filter((p) => !/coat stand|wall hanger|paper basket/i.test(p.label || ""));
      if (!pairObject && pool.length) pairObject = pool[Math.floor(Math.random() * pool.length)];
      const items = [seating.chair, seating.bench, pairObject].filter(Boolean);
      host.innerHTML = '<p class="gallery-label">Pairs well with\u2026</p><div class="eth-pairs-grid">' +
        items.map((p) => '<a href="' + p.href + '" target="_blank" rel="noopener noreferrer"><img src="' + p.img + '" alt="' + p.label + '"><span>' + p.label + "</span></a>").join("") +
        "</div>";
      host.querySelectorAll("img").forEach((img) => {
        img.addEventListener("error", () => {
          const tile = img.closest("a");
          if (tile) tile.remove();
        });
      });
    }
    function apply() {
      const it = current();
      if (!it) return;
      const colour = colourOf(it.colour);
      byId("intro").innerHTML = "<p>" + DATA.intro + "</p>" + (colour.intro_extra || "") + '<p class="seating-line">Seating: 8 to 12 people</p>';
      byId("enquireProduct").value = "Ethnicraft " + DATA.product + " \u00b7 " + sizeLabel(it);
      renderPiece(it);
      renderLife(it);
      renderAcc(it);
      renderSwatches();
      renderPairs(it);
      syncEnquireHref();
    }
    function resetZoom() {
      const zoom = byId("lightboxZoom");
      zoom.style.transform = "";
      zoom.dataset.scale = "1";
      zoom.dataset.tx = "0";
      zoom.dataset.ty = "0";
    }
    const lightboxState = { items: [], index: 0, kind: "" };
    function closeLightbox() {
      byId("lightbox").classList.remove("is-open");
      byId("lightbox").hidden = true;
      document.body.classList.remove("bok-lightbox-open");
      resetZoom();
    }
    function showLightboxItem(idx) {
      const items = lightboxState.items;
      if (!items.length) return;
      const i = ((idx % items.length) + items.length) % items.length;
      lightboxState.index = i;
      resetZoom();
      const item = items[i];
      byId("lightboxImg").src = item.src;
      byId("lightboxImg").alt = item.alt || "";
      if (lightboxState.kind === "piece") selectPiece(item);
      if (lightboxState.kind === "life") selectLife(item);
    }
    function openLightbox(kind) {
      const items = loaded(kind);
      if (!items.length) return;
      lightboxState.kind = kind;
      lightboxState.items = items.slice();
      const stageId = kind === "piece" ? "pieceImg" : "heroImg";
      const src = byId(stageId).getAttribute("data-src");
      let start = items.findIndex((x) => x.src === src);
      if (start < 0) start = 0;
      byId("lightbox").hidden = false;
      byId("lightbox").classList.add("is-open");
      document.body.classList.add("bok-lightbox-open");
      showLightboxItem(start);
    }
    function bindGallerySwipe(el, step) {
      if (!el || el.dataset.swipeBound === "1") return;
      el.dataset.swipeBound = "1";
      let startX = 0, startY = 0, active = false;
      el.addEventListener("touchstart", (e) => {
        if (e.touches.length !== 1) { active = false; return; }
        active = true; startX = e.touches[0].clientX; startY = e.touches[0].clientY;
      }, { passive: true });
      el.addEventListener("touchend", (e) => {
        if (!active) return;
        active = false;
        const t = e.changedTouches[0];
        const dx = t.clientX - startX, dy = t.clientY - startY;
        if (Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        step(dx < 0 ? 1 : -1);
      }, { passive: true });
    }
    function bindLightboxGestures() {
      const layer = byId("lightboxSwipe");
      const zoom = byId("lightboxZoom");
      if (!layer || layer.dataset.pinchBound === "1") return;
      layer.dataset.pinchBound = "1";
      let mode = "", startDist = 1, startScale = 1, startTx = 0, startTy = 0, startMidX = 0, startMidY = 0, panX = 0, panY = 0, swipeX = 0, swipeY = 0, swipeOn = false;
      function cur() { return { scale: parseFloat(zoom.dataset.scale || "1") || 1, tx: parseFloat(zoom.dataset.tx || "0") || 0, ty: parseFloat(zoom.dataset.ty || "0") || 0 }; }
      function applyZoom(s, tx, ty) {
        s = Math.min(4, Math.max(1, s));
        if (s <= 1.02) { s = 1; tx = 0; ty = 0; }
        zoom.dataset.scale = String(s); zoom.dataset.tx = String(tx); zoom.dataset.ty = String(ty);
        zoom.style.transform = s === 1 ? "" : ("translate(" + tx + "px," + ty + "px) scale(" + s + ")");
      }
      function dist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY) || 1; }
      layer.addEventListener("touchstart", (e) => {
        const pts = Array.from(e.touches);
        const now = cur();
        if (pts.length >= 2) {
          mode = "pinch"; swipeOn = false; startDist = dist(pts[0], pts[1]); startScale = now.scale; startTx = now.tx; startTy = now.ty;
          startMidX = (pts[0].clientX + pts[1].clientX) / 2; startMidY = (pts[0].clientY + pts[1].clientY) / 2;
        } else if (now.scale > 1.02) {
          mode = "pan"; swipeOn = false; panX = pts[0].clientX - now.tx; panY = pts[0].clientY - now.ty;
        } else { mode = "swipe"; swipeOn = true; swipeX = pts[0].clientX; swipeY = pts[0].clientY; }
      }, { passive: true });
      layer.addEventListener("touchmove", (e) => {
        const pts = Array.from(e.touches);
        if (pts.length >= 2 || mode === "pinch" || mode === "pan") e.preventDefault();
        if (pts.length >= 2) applyZoom(startScale * (dist(pts[0], pts[1]) / startDist), startTx + ((pts[0].clientX + pts[1].clientX) / 2 - startMidX), startTy + ((pts[0].clientY + pts[1].clientY) / 2 - startMidY));
        else if (mode === "pan" && pts.length === 1) applyZoom(cur().scale, pts[0].clientX - panX, pts[0].clientY - panY);
      }, { passive: false });
      layer.addEventListener("touchend", (e) => {
        if (mode === "swipe" && swipeOn && e.changedTouches[0] && cur().scale <= 1.02) {
          const t = e.changedTouches[0];
          const dx = t.clientX - swipeX, dy = t.clientY - swipeY;
          if (Math.abs(dx) >= 36 && Math.abs(dx) > Math.abs(dy) * 1.2) showLightboxItem(lightboxState.index + (dx < 0 ? 1 : -1));
        }
        if (e.touches.length === 0) { mode = ""; swipeOn = false; if (cur().scale < 1.05) applyZoom(1, 0, 0); }
      }, { passive: true });
    }
    function stepGallery(kind, dir) {
      const items = loaded(kind);
      if (items.length < 2) return;
      const stageId = kind === "piece" ? "pieceImg" : "heroImg";
      const src = byId(stageId).getAttribute("data-src");
      let idx = items.findIndex((x) => x.src === src);
      if (idx < 0) idx = 0;
      const i = ((idx + dir) % items.length + items.length) % items.length;
      if (kind === "piece") selectPiece(items[i]);
      else selectLife(items[i]);
    }
    byId("colour").addEventListener("change", onColour);
    byId("sku").addEventListener("change", apply);
    document.querySelectorAll("[data-lightbox]").forEach((btn) => {
      btn.addEventListener("click", () => openLightbox(btn.getAttribute("data-lightbox")));
    });
    byId("lightboxClose").addEventListener("click", closeLightbox);
    document.addEventListener("keydown", (e) => {
      if (!byId("lightbox").classList.contains("is-open")) return;
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowRight") showLightboxItem(lightboxState.index + 1);
      if (e.key === "ArrowLeft") showLightboxItem(lightboxState.index - 1);
    });
    bindGallerySwipe(byId("pieceStage"), (dir) => stepGallery("piece", dir));
    bindGallerySwipe(byId("heroStage"), (dir) => stepGallery("life", dir));
    bindLightboxGestures();
    window.addEventListener("resize", syncEnquireHref);
    function finishBoot() {
      fillColours();
      fillSizes();
      const bootSku = new URLSearchParams(location.search).get("sku");
      const bootItem = DATA.skus.find((s) => s.sku === bootSku && isListed(s));
      if (bootItem) {
        byId("colour").value = bootItem.colour;
        fillSizes();
        byId("sku").value = bootItem.sku;
      }
      apply();
    }
    const Hub = window.BaysideHubStatus;
    const handles = DATA.skus.map((s) => s.handle).filter(Boolean);
    if (Hub && Hub.loadActiveHandles && handles.length) {
      Hub.loadActiveHandles(handles).then(function (map) {
        shopifyActive = map || {};
        finishBoot();
      }).catch(finishBoot);
    } else {
      finishBoot();
    }
    const enquireForm = byId("enquireForm");
    if (enquireForm && enquireForm.getAttribute("action") !== "/contact#enquire") {
      enquireForm.addEventListener("submit", (e) => e.preventDefault());
    }
  })();
